import { createSelector } from "reselect"

export const selectClonedData = state => state?.data
export const selectClonedIdentifiers = state => state?.identifiers

export const selectFeature = state => state?.clone

export const selectData = createSelector(selectFeature, selectClonedData)

export const selectIdentifiers = createSelector(
    selectFeature,
    selectClonedIdentifiers,
)
